import { useTheme } from '@emotion/react';
import { Button, Dialog, DialogActions, Stack, Typography } from '@mui/material';
import React from 'react';
import { useRef } from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormTextField from '../../../../components/FormTextField';
import { dialogButtonCancel, dialogButtonStyle } from '../../../../utils/commonStyle';
import { showmessage } from '../../../../utils/toastr';
import { useDispatch } from 'react-redux';
import appapi from '../../../../api/apiClient';
import { setLoading } from '../../../../redux/features/appSlice';

const validationSchema = yup.object({
  blockedReason: yup.string('blockedReason').required().min(3, 'Block Reason must be at least 3 characters').max(500, 'Block Notes must be at most 500 characters').nullable(),
});

export default function BlockAndUnblockCompany({ open, handleClose, isBlockedStatus, companyId }) {
  const theme = useTheme();
  const blackMain = theme.palette.deActivate.main;
  const formRef = useRef();
  const dispatch = useDispatch();

  const sx = {
    '& .MuiDialog-container': {
      alignItems: 'center',
    },
    '& .MuiPaper-root': {
      width: '500px',
      minHeight: '224px',
      padding: '24px 16px 16px 16px',
      borderRadius: '4px',
    },
  };

  const handleBlock = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.put(`company/block/${companyId}`, { ...values });
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        showmessage(`Blocked Successfully!!`);
        handleClose(true);
        // refersh();
        // setConfirmVal('');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleUnBlock = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.put(`company/unblock/${companyId}`, { ...values });
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        showmessage(`Unblocked Successfully!!`);
        handleClose(true);
        // refersh();
        // setConfirmVal('');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={open}
      // onClose={handleClose}
      // TransitionComponent={Transition}
      className="AddUserContainer"
    >
      <Stack
        style={{ borderBottom: '1px solid rgb(112,112,112,0.3)', margin: '25px' }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div className="flex">
          {/* {inviteCheck ? '' : <PersonIcon style={{ color: '#8AB756' }} />} */}
          <Typography
            style={isBlockedStatus === '1' ? { color: theme.palette.warning.main } : { color: theme.palette.unblock.main }}
            className="fw-bold fs-16 ff-Roboto"
          >
            {/* Do you want to {isBlockedStatus === '0' ? 'Block' : 'Unblock'} {productDetail?.productName ? productDetail?.productName : ''} ? */}
            {isBlockedStatus === '1' ? 'Block' : 'Unblock'} Company
          </Typography>
        </div>
        {/* <div>
          <IconButton onClick={() => handleCloseDialog(false)}>
            <ClearIcon style={{ color: blackMain, transform: 'scale(1.143)' }} />
          </IconButton>
        </div> */}
      </Stack>
      <Typography
        style={{ color: blackMain, marginLeft: '25px', marginBottom: '20px' }}
        className="fw-medium fs-18 ff-Roboto"
      >
        Are you sure you want to {isBlockedStatus === '1' ? 'Block' : 'Unblock'} this company ?
      </Typography>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={{
          blockedReason: '',
          superAdminId: '65015cc3ea926cbb149eb1c5',
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          if (isBlockedStatus === '1') {
            handleBlock(values);
          } else {
            handleUnBlock(values);
          }
        }}
      >
        {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty }) => (
          <Form autoComplete="off">
            <Stack className="editContainer addContainer !m-[10px]">
              <Stack style={{ padding: '8px', margin: '10px', position: 'relative' }}>
                <Stack
                  className="flex"
                  direction="column"
                  justifyContent="space-between"
                  style={{ rowGap: 'initial' }}
                >
                  <Stack style={{ width: '430px' }}>
                    <FormTextField
                      name="blockedReason"
                      multiline={true}
                      maxRows={3}
                      requiredMark={true}
                      label="Reason"
                      labelRight="(Max 500 Characters)"
                      inputProps={{ maxLength: 500 }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          minHeight: '100px !important',
                          display: 'block',
                        },
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Stack>

            <DialogActions
              style={{
                height: '66px',
                justifyContent: 'center',
                paddingBottom: '40px',
                marginTop: '30px',
                marginRight: '15px',
              }}
            >
              {isBlockedStatus === '1' ? (
                <Button
                  style={{ dialogButtonStyle, width: '169px', height: '56px' }}
                  sx={{
                    width: '10px',
                    marginLeft: '24px',
                    background: '#F02323',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#F02323',
                      color: 'white',
                    },
                  }}
                  // onClick={() => handleBlock()}
                  disabled={!(dirty && isValid)}
                  variant="contained"
                  type="submit"
                >
                  Yes
                </Button>
              ) : (
                <Button
                  style={{ dialogButtonStyle, width: '169px', height: '56px' }}
                  sx={{
                    width: '10px',
                    marginLeft: '24px',
                    background: theme.palette.unblock.main,
                    color: 'white',
                    '&:hover': {
                      backgroundColor: theme.palette.unblock.main,
                      color: 'white',
                    },
                  }}
                  // onClick={() => handleBlock()}
                  disabled={!(dirty && isValid)}
                  variant="contained"
                  type="submit"
                >
                  Yes
                </Button>
              )}

              <Button
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    borderColor: '#14285A33',
                    backgroundColor: '#14285A1A',
                    '&:hover': {
                      // backgroundColor: theme.palette.secondary.main,
                      // color: theme.palette.background.main,
                      // borderColor: theme.palette.secondary.main,
                    },
                  },
                ]}
                style={{ width: '169px', marginLeft: '80px' }}
                variant="outlined"
                onClick={() => {
                  handleClose();
                  //   setConfirmVal('');
                }}
              >
                No
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
